import { render } from "./StudentLibrary.vue?vue&type=template&id=67189990&scoped=true"
import script from "./StudentLibrary.vue?vue&type=script&lang=js"
export * from "./StudentLibrary.vue?vue&type=script&lang=js"

import "./StudentLibrary.vue?vue&type=style&index=0&id=67189990&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67189990"]])

export default __exports__